<template>
    <div :class="$attrs.class">
        <label :for="id" class="form-label">{{label}}</label>
        <input :id="id" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type"  :value="modelValue" @input="updateModelValue" placeholder="d-m-Y">
        <div v-if="error" class="form-error">{{ error }}</div>
        <div v-else-if="custError" class="mt-2 text-red-500 h-8">{{ custError }}</div>
    </div>
</template>

<script>

export default{
    inheritAttrs: false,
    props: {
        id: String,
        error: String,
        custError: String,
        type: {
            type: String,
            default: 'text'
        },
        label: String,
        modelValue: String
    },
    emits: ['update:modelValue'],
    mounted: function(){
        const self = this;
        $("#"+this.id).datetimepicker({
            timepicker: false,
            format:'d-m-Y',
            lang: 'id',
            onChangeDateTime:function(dp,$input){
                self.$emit('update:modelValue',$input.val());
            }
        })
    },
    methods:{
        updateModelValue(event){
            let data = event.target.value
            data = data.replace(/-/g,"");

            let newData = ''; // declare the golbal variable to put dash

            for ( let str = 0; data.length > str; ++str )
            {
                if( str % 2 === 0 && str !== 0 && str < 5) {
                    newData += '-',newData += data[str - 0];
                }else{ 
                    newData += data[str]
                }
                
            }
            this.$emit('update:modelValue', newData)
            console.log('tgl lahir',newData)
        }
    }
}

</script>